<div class="privacy-container">
  <div class="privacy-content">
    <h1>Privacy Policy</h1>
    <p class="last-updated">Last updated: {{ getCurrentDate() }}</p>
    
    <section class="privacy-section">
      <h2>1. Introduction</h2>
      <p>Five Searches ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our AI-driven search aggregator platform.</p>
    </section>

    <section class="privacy-section">
      <h2>2. Information We Collect</h2>
      <p>We may collect information about you in a variety of ways. The information we may collect includes:</p>
      <ul>
        <li><strong>Personal Data:</strong> Name, email address, and other contact information you provide</li>
        <li><strong>Usage Data:</strong> Information about how you use our service, including search queries and interactions</li>
        <li><strong>Device Information:</strong> IP address, browser type, operating system, and device identifiers</li>
        <li><strong>Cookies and Tracking:</strong> Data collected through cookies and similar tracking technologies</li>
      </ul>
    </section>

    <section class="privacy-section">
      <h2>3. How We Use Your Information</h2>
      <p>We use the information we collect to:</p>
      <ul>
        <li>Provide, maintain, and improve our services</li>
        <li>Process your requests and transactions</li>
        <li>Send you technical notices and support messages</li>
        <li>Respond to your comments and questions</li>
        <li>Monitor and analyze usage patterns and trends</li>
        <li>Detect, prevent, and address technical issues</li>
      </ul>
    </section>

    <section class="privacy-section">
      <h2>4. Information Sharing and Disclosure</h2>
      <p>We do not sell, trade, or rent your personal information to third parties. We may share your information only in the following circumstances:</p>
      <ul>
        <li>With your consent</li>
        <li>To comply with legal obligations</li>
        <li>To protect our rights and safety</li>
        <li>With service providers who assist in operating our platform</li>
      </ul>
    </section>

    <section class="privacy-section">
      <h2>5. Data Security</h2>
      <p>We implement appropriate technical and organizational security measures to protect your personal information. However, no method of transmission over the Internet or electronic storage is 100% secure.</p>
    </section>

    <section class="privacy-section">
      <h2>6. Your Rights</h2>
      <p>You have the right to:</p>
      <ul>
        <li>Access your personal information</li>
        <li>Correct inaccurate data</li>
        <li>Request deletion of your data</li>
        <li>Object to processing of your data</li>
        <li>Request data portability</li>
      </ul>
    </section>

    <section class="privacy-section">
      <h2>7. Cookies and Tracking Technologies</h2>
      <p>We use cookies and similar tracking technologies to track activity on our platform. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.</p>
      <p>For more information about our use of cookies, please see our Cookie Policy.</p>
    </section>

    <section class="privacy-section">
      <h2>8. Third-Party Services</h2>
      <p>Our platform may contain links to third-party websites or services. We are not responsible for the privacy practices of these third parties. We encourage you to read their privacy policies.</p>
    </section>

    <section class="privacy-section">
      <h2>9. Children's Privacy</h2>
      <p>Our service is not intended for children under the age of 13. We do not knowingly collect personal information from children under 13.</p>
    </section>

    <section class="privacy-section">
      <h2>10. Changes to This Privacy Policy</h2>
      <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date.</p>
    </section>

    <section class="privacy-section">
      <h2>11. Contact Us</h2>
      <p>If you have any questions about this Privacy Policy, please contact us at:</p>
      <p>
        Email: privacy&#64;fivesearches.com<br>
        Address: 123 Search Street, Tech City, TC 12345
      </p>
    </section>

    <section class="privacy-section">
      <h2>12. Related Policies</h2>
      <p>Please also review our <a [href]="getTermsUrl()" target="_blank">Terms of Service</a> which governs your use of our platform.</p>
    </section>
  </div>
</div>
